<template>
  <article class="info-section elr-container-full">
    <div class="form-wrapper">
      <div class="info-section-header">
        <InfoSectionHeading>Create New {{singular}}</InfoSectionHeading>
        <div class="button-holder button-holder-left">
          <router-link :to="`/${plural(model)}`" class="elr-button elr-button-primary">See All {{pluralName}}</router-link>
        </div>
      </div>
      <div>
        <div v-if="role && role.id <= 1">
          <Spinner v-if="status === 'loading'" key="spinner" />
          <div v-if="status === 'success'">
            <p class="success-message">Success!</p>
            <div class="created-item">
              <router-link :to="`/${model}/${latest.id}`">View New Item</router-link>
            </div>
          </div>
          <slot />
        </div>
        <div v-else>
          <h2 class="info-section-subheading">You are not authorized to create new {{pluralName}}.</h2>
        </div>
      </div>
    </div>
  </article>
</template>

<script>
import { mapState } from 'vuex';
import { plural } from '../../utils/helpers';
import { capitalize, deslugify } from '../../utils/helpers';
import InfoSectionHeading from '../../components/InfoSectionHeading/InfoSectionHeading';
import Spinner from '../../components/Spinner/Spinner';

export default {
  name: 'CreateItem',
  props: {
    status: {
      type: String,
      default: 'success'
    },
    model: {
      type: String,
      required: true
    },
    latest: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  components: {
    InfoSectionHeading,
    Spinner
  },
  computed: {
    ...mapState({
      role: state => state.currentUser.role
    }),
    singular() {
      return this.capitalize(deslugify(this.model));
    },
    pluralName() {
      return this.plural(this.singular);
    }
  },
  methods: {
    capitalize,
    plural,
  },
}
</script>
